<template>
  <NuxtLink
    v-if="to"
    :to="to"
    class="flex cursor-pointer border-t border-grey-light-01 p-16 text-base hover:bg-grey-light-02 md:px-32 md:py-24"
    :class="{ 'md:bg-grey-light-01': isActive }"
  >
    <ul class="mr-16 flex flex-col gap-8">
      <li
        v-for="type in types"
        :key="type"
        class="flex h-32 w-32 items-center justify-center rounded-full p-6"
        :class="{
          'bg-pink text-black': isRebranding,
          'bg-grey-dark-01 text-white': !isRebranding,
        }"
      >
        <SpriteSymbol
          :name="getDistributorTypeIcon(type)"
          class="h-full w-full"
        />
      </li>
    </ul>
    <div>
      <h2 class="font-bold">
        {{ title }}
      </h2>
      <FieldItemTypeAddress v-if="address" v-bind="address" />
    </div>
  </NuxtLink>
</template>

<script lang="ts" setup>
import type {
  DistributorSearchItemFragment,
  DistributorType,
} from '#graphql-operations'

const props = defineProps<{
  id?: string
  title?: string
  isOwnBoutique?: boolean
  distributorType?: DistributorType
  isStore?: boolean
  isServiceCenter?: boolean
  address?: DistributorSearchItemFragment['address']
  url?: DistributorSearchItemFragment['url']

  isActive?: boolean
  groupId?: number
}>()

const { getDistributorTypes, getDistributorTypeIcon } = await useStoreFinder()
const isRebranding = await useFeatureFlag()

const route = useRoute()

const to = computed(() => {
  const path = props.url?.path
  if (!path) {
    return
  }

  const result = {
    path,
    query: {
      ...route.query,
    },
  }

  if (props.groupId !== undefined) {
    result.query.groupId = props.groupId.toString()
  }

  return result
})

const types = computed(() => getDistributorTypes(props))
</script>
